import { render, staticRenderFns } from "./DistrictsTab.vue?vue&type=template&id=00aa50c3&scoped=true"
import script from "./DistrictsTab.vue?vue&type=script&lang=js"
export * from "./DistrictsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa50c3",
  null
  
)

export default component.exports